var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotetop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.12155 26.502C1.77755 24.29 0.867548 21.98 0.391548 19.572C-0.0844516 17.164 -0.126452 14.798 0.265548 12.474C0.657548 10.15 1.46955 7.924 2.70155 5.796C3.96155 3.64 5.64155 1.708 7.74155 0L10.9755 1.974C11.5355 2.338 11.7875 2.786 11.7315 3.318C11.6755 3.85 11.4935 4.27 11.1855 4.578C10.5975 5.278 10.0375 6.202 9.50555 7.35C8.97355 8.498 8.59555 9.786 8.37155 11.214C8.17555 12.642 8.20355 14.168 8.45555 15.792C8.70755 17.416 9.33755 19.04 10.3455 20.664C10.8495 21.476 10.9895 22.19 10.7655 22.806C10.5415 23.394 10.0795 23.814 9.37955 24.066L3.12155 26.502ZM17.0655 26.502C15.7215 24.29 14.8115 21.98 14.3355 19.572C13.8595 17.164 13.8175 14.798 14.2095 12.474C14.6015 10.15 15.4135 7.924 16.6455 5.796C17.9056 3.64 19.5855 1.708 21.6855 0L24.9195 1.974C25.4795 2.338 25.7316 2.786 25.6756 3.318C25.6195 3.85 25.4375 4.27 25.1295 4.578C24.5415 5.278 23.9815 6.202 23.4495 7.35C22.9175 8.498 22.5395 9.786 22.3155 11.214C22.1195 12.642 22.1475 14.168 22.3995 15.792C22.6516 17.416 23.2816 19.04 24.2896 20.664C24.7935 21.476 24.9335 22.19 24.7096 22.806C24.4855 23.394 24.0236 23.814 23.3236 24.066L17.0655 26.502Z",
    fill: "#ED2028"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotetop);
export default __webpack_public_path__ + "static/media/quotetop.4eae7dd18a6f354d99425dcf11e63d99.svg";
export { ForwardRef as ReactComponent };